export const globalStyles = {
  // Common Colors
  white: '#fff',
  black: '#000',
  // ------------

  // Sizes
  size1: '4px',
  size2: '8px',
  size3: '12px',
  size4: '16px',
  size5: '20px',
  size6: '24px',
  size7: '28px',
  size8: '32px',
  size9: '36px',
  size10: '40px',
  size11: '44px',
  size12: '48px',
  size13: '52px',
  size14: '56px',
  size15: '60px',
  size16: '64px',
  size17: '68px',
  size18: '72px',
  size19: '76px',
  size20: '80px',

  pSizeXs: '12px',
  pSizeSm: '14px',
  pSize: '16px',
  pSizeLg: '18px',
  pSizeXl: '20px',

  ftWeightLight: 300,
  ftWeightNormal: 500,
  ftWeightBold: 700,

  // Common Variables
  borderRadiusBase: '8px',
  boxShadowDefault:
    '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
  componentFormWidthBase: '320px',
  componentButtonWidthBase: '128px',
  borderColorBase: '#a5b1b8',

  // Status
  success: '#14AF6E',
  successLight: '#E8F8F1',
  error: '#C10007',
  errorLight: '#FCEBEB',
  warning: '#e8c928',
  disabled: '#dce1e5',
  test: '#eb7634',
  informative: '#007bc4',
};
